export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7964.a090b44f.jpg";